export default __webpack_public_path__ + "classic_slider.png";